import { cn } from "@gettactic/helpers";
import { useRef } from "react";
import { DEFAULT_PRESETS } from "./constants";
import { CustomInput } from "./custom-input";
import { DragHandle } from "./drag-handle";
import { useDragNumber } from "./hooks/useDragNumber";
import { PresetDropdown } from "./preset-dropdown";
import { DragNumberProps, PresetOption } from "./types";

export function DragNumberInput({
  label,
  value,
  onChange,
  min = Number.NEGATIVE_INFINITY,
  max = Number.POSITIVE_INFINITY,
  step = 1,
  className,
  presets = DEFAULT_PRESETS as unknown as PresetOption[],
  placeholder,
  size = "default"
}: DragNumberProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { isDragging, handleMouseDown } = useDragNumber({
    value,
    onChange,
    min,
    max,
    step
  });

  return (
    <div className={cn("relative flex flex-col gap-2", className)}>
      {label && <span className="text-neutral-600 text-xs">{label}</span>}
      <div className="group relative">
        <DragHandle
          isDragging={isDragging}
          onMouseDown={handleMouseDown}
          size={size}
        />
        <CustomInput
          ref={inputRef}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          min={min}
          max={max}
          step={step}
          placeholder={placeholder}
          size={size}
          isDragging={isDragging}
        />
        {presets.length > 0 && (
          <div className="absolute top-0 right-0 h-full opacity-0 transition-opacity group-hover:opacity-100">
            <PresetDropdown presets={presets} onSelect={onChange} size={size} />
          </div>
        )}
      </div>
    </div>
  );
}
